module.exports = __webpack_public_path__ + "static/joueur-0e054415b2b6feb5ca69dabfa5d83790.png";